const DATE_FORMAT_PATTERNS = {
  DISPLAY_FRIENDLY_DATE: 'dd-MM-yyyy',
  REQUEST_DATE_FORMAT: 'yyyy-MM-dd',
  DAY_MONTH_YEAR: "d 'de' LLLL 'de' yyyy",
  DAY_MONTH: 'd MMM'
};

const getCurrentYear = () => new Date().getFullYear();
const MIN_YEAR = 2020;

export { DATE_FORMAT_PATTERNS, getCurrentYear, MIN_YEAR };
